import {Component, OnDestroy, OnInit} from "@angular/core";
import {Headers, Http, RequestOptions} from "@angular/http";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs/Subscription";
import {environment} from "../environments/environment";

@Component({
  templateUrl: "./html-object-edit.component.html",
})
export class HtmlObjectEditComponent implements OnInit, OnDestroy {
  id: string;
  description: string;
  html: string = "";
  sub: Subscription;

  constructor(private http: Http, private route: ActivatedRoute) {}

  save() {
    this.http.put(
      `${environment.httpBase}/objects/${encodeURIComponent(this.id)}?description=${encodeURIComponent(this.description)}`,
      this.html,
      new RequestOptions({
        withCredentials: true,
        headers: new Headers({"Content-Type": "text/html"}),
      }),
    )
      .toPromise()
      .then(
        () => {
          alert('HTML Saved');
        },
        (error) => {
          alert(error);
          console.error(error);
        },
      );
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe((params) => {
      this.id = params.id;
      if (params.id) {
        this.http.post(
          `${environment.httpBase}/objects/${params.id}`,
          {},
          new RequestOptions({withCredentials: true}),
        )
          .toPromise()
          .then(
            (result) => {
              this.description = result.headers.get("x-description");
              this.html = result.text();
            },
            (error) => {
              this.html = "";
              console.error(error);
            },
          );
      } else {
        this.html = "";
      }
    });
  }

  ngOnDestroy() {
    if (!this.sub) return;
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /var/snowriders/app/src/app/html-object-edit.component.ts